import styled from "styled-components"

const Card = styled.div`
  background-color: var(--white);
  min-height: 2rem;
  border-radius: 5px;
  overflow: hidden;
`

export default Card